/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import Button from '@vfuk/core-button';
import { cardCtaLinkWrapperStyles } from './styles/CardCtaLink.styles';

type ExternalLinkProps = {
  label: string;
  href: string;
  seoString: string;
};

const CardCtaLink = ({ label, href, seoString }: ExternalLinkProps) => {
  const handleSeoDetails = (label: string, seoString: string) => {
    if (seoString) {
      const utagData = {
        event_name: 'ui_interaction',
        event_action: 'Click Component',
        event_category: '',
        event_label: '',
        component_name: label,
        component_type: 'Button',
      };
      const seoDataList = seoString.split('|');
      for (const seoData of seoDataList) {
        const type = seoData.substring(0, seoData.indexOf('='));
        const value = seoData.substring(seoData.indexOf('=') + 1);
        if (type === 'category') {
          utagData.event_category = value;
        } else if (type === 'label') {
          utagData.event_label = value;
        }
      }
      if (
        window.utag &&
        window.utag.link &&
        typeof window.utag.link === 'function'
      ) {
        window.utag.link(utagData);
      }
    }
  };

  const onClickHandler = () => {
    handleSeoDetails(label, seoString);
  };

  return (
    <div css={cardCtaLinkWrapperStyles}>
      <Button
        text={label}
        appearance="primary"
        href={href}
        htmlAttributes={{ target: '_blank' }}
        onClick={onClickHandler}
      />
    </div>
  );
};

export default CardCtaLink;
